export default __webpack_public_path__ + "static/media/image-yx1-earphones.a059b67b.jpg";